<template>
    <div class="edit-details-step-success">
        <p class="title">You've changed the details of the event</p>
        <p class="desc">
            Once changes are confirmed by the artist, the updated details will be reflected on
            the event page
        </p>
    </div>
</template>
<script>
    export default {
        name: 'EditDetailsStepSuccess'
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }

    .edit-details-step-success {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.64px;
            max-width: 554px;
            width: 100%;
            text-wrap: nowrap;

            @media screen and (max-width: 600px) {
                text-wrap: wrap;
            }
        }
        .desc {
            color: #acacac;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
        }
    }
</style>
